<template>
  <v-sheet class="pa-2 pa-md-12">
    <v-alert class="headline" type="error" text border="left">
      Une erreur est survenue lors du paiement. Veuillez vous assurer que le montant du don est supérieur à 10$ et que le code postal indiqué
      correspond à celui de votre carte de crédit.
    </v-alert>
  </v-sheet>
</template>

<script>
export default {
  name: "ErrorView"
}
</script>

<style>
</style>